<template>
	<div class="Us">
		<div class="map pr f5">
			<div class="content pr" style="z-index: 10;pointer-events: none;">
				<div class="content_2">
					<div class="ls2 vn">
						<div class="banner_title" style="padding-top: 275px;">联系我们</div>
						<div class="banner_title_e">CONTACT US</div>
					</div>
				</div>
				<div class="cl"></div>
			</div>
			<div id="map"></div>
			<div class="Us_content pr" style="z-index: 10;">
				<div class="content">
					<div class="content_2 bff yy pr">
						<el-row>
							<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="map_col">
								<a class="map_item" :href="'tel:'+state.tel" v-if="state.mobile">
									<div class="fl mr20">
										<i class="el-icon-phone-outline"></i>
									</div>
									<div class="fl">
										<div class="f16 b c3 mt5 mb10">电话</div>
										<div class="f14 c6">{{state.tel}}</div>
									</div>
									<div class="cl"></div>
								</a>
								<div v-else class="map_item">
									<div class="fl mr20">
										<i class="el-icon-phone-outline"></i>
									</div>
									<div class="fl">
										<div class="f18 b c3 mt1 mb10">电话</div>
										<div class="f16 c6">{{state.tel}}</div>
									</div>
									<div class="cl"></div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="map_col">
								<div class="map_item">
									<div class="fl mr20">
										<i class="el-icon-location-outline"></i>
									</div>
									<div class="fl">
										<div class="f18 b c3 mt1 mb10">地址</div>
										<div class="f16 c6 hh">{{state.address}}</div>
									</div>
									<div class="cl"></div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="map_col">
								<a class="map_item" style="border: none;" :href="'mailto:'+state.e_mail"
									v-if="state.mobile">
									<div class="fl mr20">
										<i class="el-icon-message"></i>
									</div>
									<div class="fl">
										<div class="f16 b c3 mt5 mb10">邮箱</div>
										<div class="f14 c6">{{state.e_mail}}</div>
									</div>
									<div class="cl"></div>
								</a>
								<div v-else class="map_item" style="border: none;">
									<div class="fl mr20">
										<i class="el-icon-message"></i>
									</div>
									<div class="fl">
										<div class="f18 b c3 mt1 mb10">邮箱</div>
										<div class="f16 c6">{{state.e_mail}}</div>
									</div>
									<div class="cl"></div>
								</div>
							</el-col>
						</el-row>
						<div class="tool yy">
							<el-button-group>
								<el-button icon="el-icon-plus" @click="setZoom(0)"></el-button>
								<el-button icon="el-icon-minus" @click="setZoom(1)"></el-button>
							</el-button-group>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="ly" id="ly">
			<div class="content">
				<div class="content_2">
					<!-- <div class="mb30">
						<div class="fl ly_title">
							<div class="">
								<div class="f30 lh7 mt20">在线留言</div>
								<div class="f20 mb45 lh7">LEAVE A MESSAGE</div>
							</div>
						</div>
						<div class="fr tz hidden-xs-only">
							<img src="../assets/QR.png" style="width: 100px;" />
							<div class="Foot_item mt10 nohover f14">微信公众号</div>
						</div>
						<div class="cl"></div>
					</div> -->
					<div class="ptb30 plr50 pr form">
						<div class="f30 lh7 mt20">在线留言</div>
						<div class="f20 mb45 lh7">LEAVE A MESSAGE</div>
						<el-form ref="form" :model="form" label-position="top" :rules="rules">
							<el-row :gutter="50">
								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
									<el-form-item label="姓名" prop="name">
										<el-input v-model="form.name" maxlength="10"></el-input>
									</el-form-item>
									<el-form-item label="手机号码" prop="tel">
										<el-input v-model="form.tel" maxlength="11" type="tel"></el-input>
									</el-form-item>
									<el-form-item label="Email" prop="Email">
										<el-input v-model="form.Email"></el-input>
									</el-form-item>
									<el-form-item label="验证码" prop="auth">
										<el-input v-model="form.auth" maxlength="4" type="tel">
											<template #append>
												<Auth ref="Auth" v-model="auth"></Auth>
											</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
									<el-form-item label="标题" prop="title">
										<el-input v-model="form.title" maxlength="20" show-word-limit></el-input>
									</el-form-item>
									<el-form-item label="留言" prop="message">
										<el-input v-model="form.message" maxlength="200" show-word-limit type="textarea"
											resize="none"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<div class="pb50"></div>
							<div class="submit">
								<el-button type="primary" @click="onSubmit('form')">提 交</el-button>
							</div>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import AMapLoader from '@amap/amap-jsapi-loader';
	export default {
		components: {
			Auth: window.$in('components/Auth.vue')
		},
		data() {
			return {
				auth: '',
				map: '',
				form: {},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					tel: [{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					}, {
						validator: this.tel,
						trigger: 'blur'
					}],
					Email: [{
						required: true,
						message: '请输入邮箱地址',
						trigger: 'blur'
					}],
					auth: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}, {
						validator: this.authRight,
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}],
					message: [{
						required: true,
						message: '请输入留言',
						trigger: 'blur'
					}]
				}
			}
		},
		computed: {
			state() {
				return this.$store.state
			}
		},
		mounted() {
			this.initMap();
		},
		unmounted() {
			if (this.map) {
				this.map.destroy();
			}
		},
		methods: {
			authRight(rule, value, callback) {
				if (value != this.auth) {
					callback(new Error('验证码错误'));
				} else {
					callback();
				}
			},
			tel(rule, value, callback) {
				if (value.length < 11 || value.substr(0, 1) != 1) {
					callback(new Error('请输入正确的手机号码'));
				} else {
					callback();
				}
			},
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$alert('留言成功！', '在线留言', {
							callback: action => {
								this.$refs[formName].resetFields();
								this.$refs['Auth'].random();
							}
						})
					} else {
						this.$refs['Auth'].random()
					}
				});
			},
			initMap() {
				if (this.map) {
					return;
				}
				try {
					AMapLoader.load({
							"key": "b6cb8d27eba43cb381947d97ecb97c69", // 申请好的Web端开发者Key，首次调用 load 时必填
							"version": "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
							"plugins": [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
							"AMapUI": { // 是否加载 AMapUI，缺省不加载
								"version": '1.1', // AMapUI 缺省 1.1
								"plugins": [], // 需要加载的 AMapUI ui插件
							},
							"Loca": { // 是否加载 Loca， 缺省不加载
								"version": '1.3.2' // Loca 版本，缺省 1.3.2
							},
						}).then((AMap) => {
							var center = [125.229652, 43.825485];

							this.map = new AMap.Map('map', {
								resizeEnable: true, //是否监控地图容器尺寸变化
								mapStyle: 'amap://styles/macaron', //whitesmoke
								center: center, //设置地图中心点坐标
								zoom: 11, //设置地图显示的缩放级别
								zooms: [7, 17],
								scrollWheel: false, //鼠标滚轮
								// jogEnable: false, //缓动
							});

							var content = '<div class="c6 now">' + this.state.name + '</div>';

							var marker = new AMap.Marker({
								position: center, // 基点位置
								offset: new AMap.Pixel(0, 0), // 设置点标记偏移量
								anchor: 'bottom-center', // 设置锚点方位
								icon: new AMap.Icon({
									image: require('@/assets/logo.png'),
									size: new AMap.Size(40, 40),
									imageSize: new AMap.Size(40, 40),
									// imageOffset: new AMap.Pixel(0, -20)
								})
							});

							this.map.add(marker);

							var infoWindow = new AMap.InfoWindow({
								content: content, //传入 dom 对象，或者 html 字符串
								anchor: 'bottom-center',
								offset: new AMap.Pixel(0, -50),
								// showShadow: true,
							});

							infoWindow.open(this.map, this.map.getCenter());

							this.map.on('complete', e => {
								this.map.setZoom(14)
							});
						})
						.catch(e => {
							// console.log(e)
							// setTimeout(() => {
							// 	this.initMap()
							// }, 1000)
						})
				} catch (e) {}
			},
			setZoom(n) {
				var zoom = this.map.getZoom();
				this.map.setZoom(n ? zoom - 1 : zoom + 1)
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/theme.scss';

	.Us {
		a {
			text-decoration: none;
		}
		
		@media screen and (max-width: 768px) {
			.f30 {
				font-size: 7vw;
			}
			.plr50 {
				padding-left: 4vw;
				padding-right: 4vw;
			}
		}

		.submit {
			button {
				width: 160px;
				height: 60px;
				border-radius: 2px;
				font-size: 18px;
			}

			text-align: center;
			position: absolute;
			left: 50%;
			margin-left: -80px;
		}

		.map {
			height: 600px;
			overflow: hidden;

			@media screen and (max-width: 768px) {
				height: 400px;
				overflow: inherit;

				.amap-logo {
					display: none !important;
				}
			}
		}

		#map {
			position: absolute;
			left: 0;
			right: 0%;
			top: -25%;
			bottom: 0;

			@media screen and (max-width: 768px) {
				right: 0;
				top: 0;
				bottom: 0%;
			}

			.amap-overlays {
				z-index: 1;
			}

			// .amap-marker {
			// 	animation: tao 2s infinite alternate;
			// }

			// @keyframes tao
			// {
			// 	0%   {top: -33px;}
			// 	50%  {top:-45px;}
			// 	100% {top:-33px;}
			// }
			
			.amap-marker {
				position: relative;
				
				img {
					// visibility: hidden;
					background-color: #fff;
					border-radius: 3px;
				}
			}

			// .amap-marker::before {
			// 	content: '';
			// 	height: 8px;
			// 	width: 40px;
			// 	background: #000;
			// 	opacity: .2;
			// 	border-radius: 50%;
			// 	position: absolute;
			// 	top: 67px;
			// 	left: 0;
			// 	animation: shadow 0.8s linear infinite;
			// }

			// .amap-marker::after {
			// 	border-radius: 5px;
			// 	background-image: url(../assets/logo.png);
			// 	background-size: cover;
			// 	background-color: #FFFFFF;
			// 	animation: rotate 0.8s linear infinite;
			// 	content: '';
			// 	position: absolute;
			// 	left: 0;
			// 	top: 0;
			// 	width: 40px;
			// 	height: 40px;
			// }

			@keyframes shadow {

				0%,
				100% {
					transform: scaleX(1);
				}

				50% {
					transform: scaleX(1.2);
				}
			}

			@keyframes rotate {
				0% {
					transform: translateY(0);
				}

				25% {
					transform: translateY(10px);
				}

				50% {
					transform: translateY(20px) scale(1.1, 0.9);

				}

				75% {
					ransform: translateY(10px);
				}

				100% {
					transform: translateY(0);
				}
			}
		}

		.map_col {
			.map_item {
				padding: 0 30px;
				margin: 30px 0;
				border-right: 1px solid #e6e6e6;

				i {
					font-size: 40px;
					border: 2px solid rgba(255, 255, 255, 0);
					border-radius: 100%;
					padding: 10px;
					color: #999;
				}

				display: flex;
				align-items: center;
				justify-content: left;

				@media screen and (max-width: 768px) {
					margin: 0;
					padding: 4vw;
					border: none;

					i {
						font-size: 26px;
						padding: 2vw;
					}
				}
			}

			// cursor: default;
			background-color: #FFFFFF;

			&:hover {
				background-color: $blue;

				.c3,
				.c6,
				i {
					color: #FFFFFF;
				}

				i {
					border-color: #FFFFFF;
				}

				.map_item {
					border: none;
				}
			}
		}

		.Us_content {
			margin-top: 0; // 195px;

			@media screen and (max-width: 768px) {
				margin-left: 2vw;
				margin-right: 2vw;
				margin-top: 225px;
				// z-index: 1000000!important;
			}
		}

		.amap-info-close {
			display: none;
		}

		.amap-info-content {
			padding: 10px;
		}

		.ly {
			padding: 0px 0 100px;
			margin-bottom: 1px;
			position: relative;
			background: url(../assets/Us.png) no-repeat center;

			textarea {
				height: 264px;
			}

			@media screen and (max-width: 768px) {
				// padding-top: calc(24vw + 110px);
				padding-top: 240px;
				padding-bottom: 80px;

				.ly_title {
					width: 100%;
				}

				.form {
					margin: 0 2vw;

					.el-form-item {
						margin-bottom: 2vw;
					}
				}
			}
		}

		.el-input-group__append {
			padding: 0;
		}

		.tool {
			position: absolute;
			right: 0;
			top: -60px;
		}
		
		.el-form-item__label {
			font-size: 16px;
		}
		
		.el-form-item {
			margin-bottom: 10px;
		}
	}
</style>
